import { PickupParticipantEditPage } from "components/shared/pickupParticipants";
import { EditInformationSection as InformationSection } from "../../components/form/InformationSection";
import { EditPickupInformationSection as PickupInformationSection } from "../../components/form/PickupSection";
import { EditRegistrationInformationSection as RegistrationInformationSection } from "../../components/form/RegistrationSection";

const WPSCheckinSportParticipantsEditPage = () => (
  <PickupParticipantEditPage
    kind="sport"
    variant="wps"
    sections={{
      InformationSection,
      RegistrationInformationSection,
      PickupInformationSection,
    }}
  />
);

export default WPSCheckinSportParticipantsEditPage;
